module.exports = __webpack_public_path__ + "h5/img/hong-kong-incorporation-thumb.551ff8ab.webp";